import {TouchableOpacity, View} from "react-native";
import {DialogHeaderBack} from "./assets/DialogHeaderBack";
import React, {useContext} from "react";
import AppConfigContext from "../../contexts/AppConfigContext";
import {Colors} from "./colors";
import Text from "./components/Text";
import FontAwesome from "./components/FontAwesome";
import {useFocusEffect} from "@react-navigation/native";

export default function DialogPage(props: { navigation: any, header: string, children: any }) {
    const configContext = useContext(AppConfigContext);
    const colors = Colors.instance(configContext.theme, configContext.color);

    useFocusEffect(React.useCallback(() => {
        configContext.setPageTitle("");
        configContext.setIfPageHasHeader(false);
    }, []));

    return <View style={{
        backgroundColor: colors.get("transparentBackground") as string,
        flex: 1, alignItems: 'center', justifyContent: 'center'
    }}>
        <View style={{
            borderRadius: 20,
            overflow: "hidden",
            backgroundColor: colors.get("highConBackground") as string,
            flexDirection: "column",
            width: "100%",
            maxWidth: 314
        }}>
            <View style={{width: "100%", flexDirection: "row"}}>

                <DialogHeaderBack style={{
                    position: "absolute",
                    width: "100%"
                }} color={colors.get("primaryColor")}/>

                <View style={{
                    width: "100%",
                    paddingVertical: 12,
                    paddingHorizontal: 18,
                    flexDirection: "row",
                    justifyContent: "space-between"
                }}>
                    <Text color={"#fff"}>{props.header}</Text>
                    <TouchableOpacity onPress={() => props.navigation.goBack()}>
                        <FontAwesome color={"#fff"} icon={""}/>
                    </TouchableOpacity>
                </View>

            </View>

            <View style={{padding: 20, width: "100%"}}>
                {props.children}
            </View>

        </View>
    </View>
}